import { d_flex_center } from '../../styles/common';
import { styled, CircularProgress, circularProgressClasses, Box, SxProps, Theme } from '@mui/material';

interface StyledLoadingBoxProps {
  is_alert?: boolean;
  is_fetch?: boolean;
  is_calendar?: boolean;
  is_magazine?: boolean;
  is_abs?: boolean;
  is_councel?: boolean;
  is_full_size?: boolean;
  is_attendance?: boolean;
}

const StyledLoadingBox = styled(Box)<StyledLoadingBoxProps>(props => {
  const alert_style =
    props.is_alert || props.is_full_size
      ? {
          height: '100%',
          width: '100%',
          zIndex: '999',
          backgroundColor: 'rgba(33, 33, 33, 0.46)',
          top: '0',
          left: '0',
        }
      : {};
  const calendar_style = props.is_calendar ? { height: 'auto', marginTop: '2rem' } : {};
  const magazine_style = props.is_magazine ? { height: 'calc(100% - 6.315% - 1.5rem)' } : {};
  const abs_style = props.is_abs ? { zIndex: '90', width: 'calc(100% - 36px)', backgroundColor: '#fff' } : {};
  const attendance_style = props.is_attendance
    ? {
        zIndex: '90',
        width: 'calc(100% )',
        backgroundColor: 'rgba(255, 255, 255, 0.46)',
        height: 'calc(100%)',
        top: '0',
      }
    : {};
  return {
    width: '100%',
    height: props.is_councel ? '100%' : 'calc(100vh)',
    position:
      props.is_abs || props.is_alert || props.is_attendance ? 'absolute' : props.is_full_size ? 'fixed' : 'relative',
    ...d_flex_center,
    ...alert_style,
    ...calendar_style,
    ...magazine_style,
    ...abs_style,
    ...attendance_style,
  };
});

const StyledLoadingLabel = styled(Box)<StyledLoadingBoxProps>(props => ({
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: props.is_alert || props.is_full_size ? '#fff !important' : props.theme.palette.gray_1.main,
  fontSize: '1.5rem',
  fontWeight: 'bold',
  position: 'absolute',
}));

const StyledCircularProgressBottom = styled(CircularProgress)(props => ({
  color: props.theme.palette.grey[props.theme.palette.mode === 'light' ? 300 : 800],
}));

const StyledCircularProgressTop = styled(CircularProgress)(props => ({
  // color: props.theme.palette.mode === 'light' ? props.theme.palette.green.main : props.theme.palette.yellow_green.main,
  color: '#f23322',
  animationDuration: '650ms',
  position: 'absolute',
}));

const StyledLoadingLogoWrap = styled(Box)({
  width: '100vw',
  height: '100vh',
  position: 'absolute',
  zIndex: '99999',
  ...d_flex_center,
});

const StyledLogo = styled('img')({
  width: '15%',
  height: '15%',
});

interface LoadingProps {
  isLogo?: boolean;
  isAlert?: boolean;
  isAbs?: boolean;
  isCalendar?: boolean;
  isMagazine?: boolean;
  isCouncel?: boolean;
  isFullSize?: boolean;
  isAttendance?: boolean;
  sx?: SxProps<Theme>;
}

function Loading(props: LoadingProps) {
  const is_logo = props.isLogo;
  const is_alert = props.isAlert;
  const is_calendar = props.isCalendar;
  const is_magazine = props.isMagazine;
  const is_abs = props.isAbs;
  const is_councel = props.isCouncel;
  const is_full_size = props.isFullSize;
  const is_attendance = props.isAttendance;
  const sx = props.sx;

  return (
    <>
      {is_logo ? (
        <StyledLoadingLogoWrap>
          <StyledLogo src={'https://kr.object.ncloudstorage.com/cdn-irontrain/common/images/checkbus_V2_textE.svg'} />
        </StyledLoadingLogoWrap>
      ) : (
        <StyledLoadingBox
          is_alert={is_alert}
          is_calendar={is_calendar}
          is_magazine={is_magazine}
          is_councel={is_councel}
          is_abs={is_abs}
          is_full_size={is_full_size}
          is_attendance={is_attendance}
          id='Loading-box'
          sx={sx}
        >
          <StyledCircularProgressBottom variant='determinate' size={'10rem'} thickness={4} value={100} />
          <StyledCircularProgressTop
            variant='indeterminate'
            disableShrink
            sx={{
              [`& .${circularProgressClasses.circle}`]: {
                strokeLinecap: 'round',
              },
            }}
            size={'10rem'}
            thickness={4}
          />
          <StyledLoadingLabel is_alert={is_alert} is_full_size={is_full_size} is_attendance={is_attendance}>
            Loading
          </StyledLoadingLabel>
        </StyledLoadingBox>
      )}
    </>
  );
}

export default Loading;
